// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import Vue from 'vue'
import App from './App'
import { router } from './router'
// import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
Vue.use(ElementUI)
import HttpUtils from '@/js/utils/http.utils'
Vue.use(HttpUtils)
Vue.prototype.HttpUtils = HttpUtils
import JsonViewEditor from 'vue-json-view-editor'
Vue.use(JsonViewEditor)

import CommonSrv from "@/js/utils/common-service";
Vue.use(CommonSrv)
Vue.prototype.CommonSrv = CommonSrv

//注册全局过滤方法
import { toThousands } from '@/js/utils/filter'
Vue.filter('toThousands',toThousands)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})






// WEBPACK FOOTER //
// ./src/js/main.js